import CourseForm from '@/components/CourseForm'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		data: {},
		...opts,
		vueComponent: CourseForm
	}

	let page = vuewidget(dom, options)
	return page
}